module.exports = __webpack_public_path__ + "img/hkliilogo_dark.78eb48cc.svg";